import {makeLxTranslations} from "@lxo-blocks/react";

const MFARESET_FORM_TRANSLATION = makeLxTranslations({
    namespace: "mfaResetFormTranslations",
    translations: {
        RESETCODE: "Ersatzcode",
        MFA_RESET_CODE_REQUIRED: "Bitte geben Sie Ihren Ersatzcode ein",
        MFA_RESET_SUBMIT: "BESTÄTIGEN UND ANMELDEN",
        CREDENTIALS_LOGIN_MFA_RESET_FAILED: "Der eingegebene Ersatzcode ist ungültig.",
        CREDENTIALS_LOGIN_MFA_RESET_FAILED_TRY_AGAIN: "Bitte versuchen Sie es erneut oder wenden Sie sich an den Support.",
        RESET_MFA_HINT_HEADLINE: "Hinweis",
        RESET_MFA_HINT: "Die Zwei-Faktor-Authentifizierung wird deaktiviert. Gehen Sie in Ihr Benutzerkonto / Profil, um diese wieder zu aktivieren.",


    }
});

export {MFARESET_FORM_TRANSLATION};
